import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

/**
 * A Simple divider component that can be used to separate content.
 */ const Divider = ({ animationType, animationDelay = 0, className, light = false })=>jsx("hr", {
        className: classNames('border-end my-0', animationType, className),
        style: {
            '--animation-delay': animationDelay,
            'borderColor': light ? 'var(--border-colors-divider-divider-light)' : 'var(--border-colors-divider-divider-default)'
        }
    });

export { Divider };
